export const NAME = 'register'
export const LABEL = 'Register'
export const PATH = `/${NAME}/`
export const FORM = 'YoungPerson'

export const subForms = [
  {
    id: 1,
    label: 'Register',
    path: '/register/',
    configName: 'register'
  },
  {
    id: 2,
    label: 'Care Planning',
    path: '/register/careplanning/',
    configName: 'carePlans',
    dataFunctionName: 'getCarePlanningData'
  },
  {
    id: 3,
    label: 'Communications',
    path: '/register/communications/',
    configName: 'communications',
    dataFunctionName: 'getCommunicationsData'
  },
  {
    id: 4,
    label: 'Consequences',
    path: '/register/consequences/',
    configName: 'consequences',
    dataFunctionName: 'getConsequencesData'
  },
  {
    id: 5,
    label: 'Consultation',
    path: '/register/consultations/',
    configName: 'consultations',
    dataFunctionName: 'getConsultationsData'
  },
  {
    id: 6,
    label: 'Decisions',
    path: '/register/decisions/',
    configName: 'decisions',
    dataFunctionName: 'getDecisionsData'
  },
  {
    id: 7,
    label: 'Events',
    path: '/register/events/',
    configName: 'events',
    dataFunctionName: 'getEventsData'
  },
  {
    id: 8,
    label: 'Placement Planning',
    path: '/register/placementplanning/',
    configName: 'placementPlans',
    dataFunctionName: 'getPlacementPlansData'
  },
  {
    id: 9,
    label: 'Professional Advice',
    path: '/register/advices/',
    configName: 'professionalAdvices',
    dataFunctionName: 'getProfessionalAdvicesData'
  },
  {
    id: 10,
    label: 'Risks',
    path: '/register/risks/',
    configName: 'risks',
    dataFunctionName: 'getRisksData'
  },
  {
    id: 11,
    label: 'Significant Events',
    path: '/register/significantevents/',
    configName: 'significantEvents',
    dataFunctionName: 'getSignificantEventsData'
  },
  {
    id: 12,
    label: 'Training',
    path: '/register/trainings/',
    configName: 'trainings',
    dataFunctionName: 'getTrainingsData'
  }
]



// WEBPACK FOOTER //
// ./src/register/constants.js